import { render } from "./GhostJar.vue?vue&type=template&id=f813f432&scoped=true"
import script from "./GhostJar.vue?vue&type=script&lang=js"
export * from "./GhostJar.vue?vue&type=script&lang=js"

import "./GhostJar.vue?vue&type=style&index=0&id=f813f432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f813f432"]])

export default __exports__